import React from "react";
import {Navigate, useLocation} from "react-router-dom";
import {NavigateProps} from "react-router";

export const Redirect: React.FC<NavigateProps> = ({to, ...rest}) => {
	const {search} = useLocation();

	return <Navigate to={`/${search}`} {...rest} />;
};
